'use strict';

var angular = require('angular');
var RecalculatePersistModalDirective = function RecalculatePersistModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'RecalculatePersistModalController',
    template: require('../templates/recalculate-persist-modal.html'),
    link: function link($scope, element) {
      $scope.$watch('isShowConfirmMadal', function (newVal) {
        if (newVal) {
          angular.element('#recalculate-persist-modal').modal('show');
        } else {
          element.parent('.modal:first').modal('hide');
        }
      });
    }
  };
};
RecalculatePersistModalDirective.$inject = [];
module.exports = RecalculatePersistModalDirective;